import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import { toastError } from '@components/Toast';

import TeamChip from '@features/filter/Common/TeamChip';
import { generateTeamParams, isTeamFilterExist } from '@features/filter/static/filterUtil';
import UsersForTeamLead from '@features/filter/v1/core/UsersForTeamLead';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import {
	fetchPhotographyCount,
	fetchPhotographyRequestByStatus,
	setPhotographyFilterField
} from '@store/actions/PhotographyAction';
import { clearTeamFilter } from '@store/actions/TeamMemberAction';
import { fetchUserList } from '@store/actions/UserAction';

import ApiClient from '@lib/apiClient';

import { changeDateFormat, checkAnyUserType, checkSingular, isPageReachBottom } from '@utils/Util';

const ListOfCollection = () => {
	const [activeTab, setActiveTab] = useState('Pending');
	const [showSearchBox, setShowSearchBox] = useState(false);
	const [collectionList, setCollectionList] = useState([]);
	const [listOfPhotography, setListOfPhotography] = useState([]);
	const [userList, setUserList] = useState([]);
	const dispatch = useDispatch();
	const [inputData, setInputData] = useState({});
	const userStore = useSelector((store) => store.userStore);
	const photographyStore = useSelector((store) => store.photographyStore);
	const myStateRef = useRef({});
	const navigate = useNavigate();
	const myTeamMembers = useSelector((store) => store.teamMembersReducer);

	const myTeamRef = useRef({});
	const isDataLoading = useRef(false);

	const setIsDataLoading = (data) => {
		isDataLoading.current = data;
	};

	const setMyState = (data) => {
		myStateRef.current = data;
	};

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, [activeTab]);

	useEffect(() => {
		myTeamRef.current = myTeamMembers;
	}, [myTeamMembers]);

	const generateParams = (pageNumber) => {
		let params = `?page=${pageNumber}&size=15&status=${activeTab.toUpperCase()}&sort=lastModified,desc`;
		if (Object.keys(photographyStore.filterField).length > 0) {
			if (photographyStore.filterField?.search) {
				params += `&search=${photographyStore.filterField?.search}`;
			}
			if (photographyStore.filterField?.collection?.id) {
				params += `&collectionId=${photographyStore.filterField.collection.id}`;
			}
			if (photographyStore.filterField?.requestedBy?.id) {
				params += `&requestedBy=${photographyStore.filterField.requestedBy.id}`;
			}
		}
		return generateTeamParams(myTeamRef.current, params);
	};

	const fetchPhotographyRequest = (pageNumber) => {
		dispatch(openLoader());
		dispatch(fetchPhotographyRequestByStatus(generateParams(pageNumber))).finally(() => {
			dispatch(closeLoader());
			setIsDataLoading(false);
		});
	};

	const handleScroll = () => {
		if (isPageReachBottom() && myStateRef.current) {
			let { totalElements, currentPage, data } = myStateRef.current;
			if (totalElements > 0 && totalElements !== data.length && !isDataLoading.current) {
				setIsDataLoading(true);
				fetchPhotographyRequest(currentPage + 1);
			}
		}
	};

	useEffect(() => {
		let pageNumber = 0;
		if (!myStateRef.current) {
			pageNumber = myStateRef.current.currentPage;
		}
		dispatch(fetchPhotographyCount(generateParams(0)));
		fetchPhotographyRequest(pageNumber);
	}, [activeTab, photographyStore.filterField, myTeamMembers]);

	useEffect(() => {
		setListOfPhotography(photographyStore.response);
		setMyState(photographyStore.response);
	}, [photographyStore.response]);

	const fetchCollectionList = async (search) => {
		let params = search !== undefined ? `PHOTOGRAPHY?search=${search}` : 'PHOTOGRAPHY';
		await ApiClient.GET('fetchCollectionForSample', params)
			.then(({ data }) => {
				let lists = [];
				data.data.map((item) => lists.push({ id: item.id, value: item.name }));
				setCollectionList(lists);
			})
			.catch(() => {
				toastError('Unable to fetch collection list!');
			});
	};

	useEffect(() => {
		fetchCollectionList();
		dispatch(fetchUserList());
	}, []);

	useEffect(() => {
		if (userStore.length > 0) {
			let users = [];
			userStore.map((user) => users.push({ id: user.id, value: user.name }));
			setUserList(users);
		}
	}, [userStore]);

	const handleTab = (value) => {
		setActiveTab(value);
	};

	const handleDropDown = (item) => {
		let cloneObj = {
			...inputData,
			collection: { ...inputData.collection },
			user: { ...inputData.user }
		};
		if (item?.title !== undefined) {
			let key;
			if (item.title === 'Collection') {
				key = 'collection';
			} else {
				key = 'user';
			}
			cloneObj[key] = {
				id: item.id,
				value: item.value
			};
			setInputData(cloneObj);
			handleFilter(cloneObj);
		}
	};
	const handleFilter = (cloneObj) => {
		let postData = {};
		if (cloneObj?.search) {
			postData.search = cloneObj.search;
		}
		if (cloneObj?.collection?.id) {
			postData.collection = cloneObj.collection;
		}
		if (cloneObj?.user?.id) {
			postData.requestedBy = cloneObj.user;
		}
		dispatch(setPhotographyFilterField(postData));
	};

	const handleChange = (e) => {
		let cloneObj = {
			...inputData,
			collection: { ...inputData.collection },
			user: { ...inputData.user },
			search: e.target.value
		};
		setInputData(cloneObj);
		handleFilter(cloneObj);
	};

	const renderDesign = () => {
		return listOfPhotography?.data?.map((item) => {
			return (
				<div
					onClick={() => navigate(`/collections/view/${item?.id}?requestFrom=photography`)}
					className="single-collection-item"
					key={`photography_item_${item.id}`}
				>
					<div className="product-img-container">
						<div className="prev-img">
							{item?.documentPathList && item?.documentPathList[0] ? (
								<img src={item?.documentPathList[0]} alt="" />
							) : (
								<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
							)}
						</div>
						<div className="prev-img-thumb">
							<div className="single-first">
								{item?.documentPathList && item?.documentPathList[1] ? (
									<img src={item?.documentPathList[1]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
							<div className="single-second">
								{item?.documentPathList && item?.documentPathList[2] ? (
									<img src={item?.documentPathList[2]} alt="" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								)}
							</div>
						</div>
					</div>
					<div className="design-details d-flex justify-content-between">
						<div className="photoshoot-status">
							<p className="regular-14 gray_dark_02">
								<span className="green">{item?.completedPhotography}</span>/
								{parseInt(item?.pendingPhotography) + parseInt(item?.completedPhotography)}
							</p>
						</div>
						<div className="design-details d-flex justify-content-between">
							<div className="details">
								<p className="collection-title regular-12 mb-0 gray_dark_01 weight-500">
									{item?.collectionName}
								</p>
								<ul className="common-list-component mt-1">
									<li>
										<span className="name gray_dark_02">
											{item?.photographyRequestedBy}
										</span>
									</li>
									<li>
										<span className="weight-300 gray_dark_01">{item?.brand}</span>
									</li>
									<li>
										<p className="gray_dark_02">
											<span className="weight-300">REQ</span>
											<span className="gray_dark_01 ml-2">
												{changeDateFormat(
													item?.photographyFirstCreatedAt,
													'YYYY-MM-DD',
													'DD MMM'
												)}
											</span>
										</p>
									</li>
									<li>
										<p className="gray_dark_02">
											<span className="weight-300">RQD</span>
											<span className="gray_dark_01 ml-2">
												{changeDateFormat(
													item?.photographyLastRequireDate,
													'YYYY-MM-DD',
													'DD MMM'
												)}
											</span>
										</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			);
		});
	};

	const renderAlertMessage = () => {
		if (listOfPhotography?.data?.length === 0) {
			return (
				<div className="alert alert-secondary text-center">
					<p>No photography request found</p>
				</div>
			);
		}
	};

	const isShowClear = () => {
		return Object.keys(photographyStore.filterField).length > 0;
	};
	const handleSearch = (value) => {
		dispatch(openLoader());
		fetchCollectionList(value).finally(() => dispatch(closeLoader()));
	};

	const onUserSearch = (value) => dispatch(fetchUserList(value));

	const isUserExecutor = () => {
		return checkAnyUserType(['ADMIN', 'PHOTOGRAPHY']);
	};

	return (
		<div>
			<div className="top-header bg-white">
				<div className="page-title-area">
					<h1 className="semibold-16">Photoshoot</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">
					<ul>
						<li
							onClick={() => handleTab('Pending')}
							className={activeTab === 'Pending' ? 'active' : ''}
						>
							Pending
						</li>
						<li
							onClick={() => handleTab('Completed')}
							className={activeTab === 'Completed' ? 'active' : ''}
						>
							Completed
						</li>
					</ul>
				</div>
				<div className="filter-container-top pt-2 pb-2">
					<div className="filters">
						<div className="samples-summary on-photoshoot">
							<ul className="common-list-component">
								<li>
									<span> {myStateRef.current?.totalElements} Request</span>
									{activeTab === 'Pending' && (
										<>
											<span>
												,{' '}
												{checkSingular(
													'Style',
													`${photographyStore?.countResponse?.total || 0}`
												)}
											</span>
										</>
									)}
								</li>
								<li>
									{' '}
									{activeTab === 'Pending' ? (
										<>
											<span>
												Completed:{' '}
												{checkSingular(
													'Style',
													`${photographyStore?.countResponse?.COMPLETED || 0}`
												)}
											</span>
										</>
									) : (
										<span>
											Completed:{' '}
											{checkSingular(
												'Style',
												`${photographyStore?.countResponse?.COMPLETED || 0}`
											)}
										</span>
									)}
									,{' '}
									<span>
										Today:{' '}
										{checkSingular(
											'Style',
											`${photographyStore?.countResponse?.TODAY || 0}`
										)}
									</span>
								</li>
							</ul>
						</div>
						<TeamChip />
					</div>
					<div className="filter-actions sample-dashboard-filter">
						<div className="form-group size32 m-0 search-filter filter-with-animation">
							<div
								className={
									!showSearchBox ? 'with-icon right-icon hidden' : 'with-icon right-icon'
								}
							>
								<input
									type="text"
									placeholder="Design name & number"
									name="search"
									value={photographyStore?.filterField?.search || ''}
									onChange={handleChange}
									autoComplete="off"
								/>
								<span
									onClick={() => setShowSearchBox((prevState) => !prevState)}
									className="right-icon"
								>
									<img src={`${process.env.PUBLIC_URL}/icons/search-dark.svg`} alt="" />
								</span>
							</div>
						</div>
						{(isShowClear() || isTeamFilterExist(myTeamMembers)) && (
							<span
								className="clear-btn"
								onClick={() => {
									dispatch(clearTeamFilter());
									dispatch(setPhotographyFilterField({}));
									setInputData({});
								}}
							>
								Clear
							</span>
						)}
						<div className="single-filter">
							<CustomDropdown
								type="addItem"
								title={'Collection'}
								onItemSearch={handleSearch}
								onItemClick={handleDropDown}
								items={collectionList}
								selectedItem={photographyStore?.filterField?.collection?.value}
							/>
						</div>
						<div className="single-filter">
							{isUserExecutor() && (
								<CustomDropdown
									type="addItem"
									title={'Requested By'}
									onItemClick={handleDropDown}
									items={userList}
									onItemSearch={onUserSearch}
									selectedItem={photographyStore?.filterField?.requestedBy?.value}
								/>
							)}
							{isUserExecutor() === false && <UsersForTeamLead />}
						</div>
					</div>
				</div>
			</div>
			<div className="sample-dashboard-container bg-white">
				<div className="designs-collections-container">
					{renderAlertMessage()}
					<div className="collections-row">{renderDesign()}</div>
				</div>
			</div>
		</div>
	);
};

export default ListOfCollection;
